import debounce from "lodash.debounce";
import { isLoading } from "./requestStateHelper";

const MOBILE_WIDTH_BREAKPOINT = 576;
const MOBILE_EXTRA_MARGIN = 6;

// @todo Move to external configuration
const zendeskConfig = {
  "albelli.nl": {
    enabled: true,
    key: "972372cd-4289-439f-a333-abb36a4e679c",
    department: "albelli NL"
  },
  "albelli.be": {
    enabled: true,
    key: "0ba6fdfa-6c73-4dc1-b029-86214fda9510",
    department: "albelli BE"
  },
  "bonusprint.co.uk": {
    enabled: true,
    key: "3c71d25e-9102-4447-991f-864720a839ef",
    department: "bonusprint"
  },
  "monalbumphoto.fr": {
    enabled: true,
    key: "09c45ef3-31c5-468d-906b-b50cb6900e6c",
    department: "monalbumphoto - 1st Line"
  },
  "onskefoto.se": {
    enabled: true,
    key: "da0c90f4-c66c-4768-ba62-c2dd5a6f2b63",
    department: "onskefoto"
  },
  "fotoknudsen.no": {
    enabled: true,
    key: "c857c7c3-6835-4304-851f-b79a3babe4b2",
    department: "fotoknudsen"
  }
};
const zendeskBaseUrl = "https://static.zdassets.com/ekr/snippet.js?key=";

let liveChatInitialized = false;

export const liveChatHelper = channel => {
  if (liveChatInitialized || isLoading(channel)) {
    return;
  }
  liveChatInitialized = true;

  const zendeskVendorConfig = zendeskConfig[channel.ID];

  if (!zendeskVendorConfig || !zendeskVendorConfig.enabled) {
    return;
  }

  window.zESettings = {
    webWidget: {
      zIndex: 18,
      offset: {
        vertical: 0,
        // Update "mobile" which is used for tablet and touch devices
        mobile: {
          vertical: MOBILE_EXTRA_MARGIN
        }
      },
      chat: {
        departments: {
          enabled: [],
          select: zendeskVendorConfig.department
        }
      }
    }
  };

  const zendeskScript = document.createElement("script");
  zendeskScript.id = "ze-snippet";
  zendeskScript.src = zendeskBaseUrl + zendeskVendorConfig.key;
  document.body.appendChild(zendeskScript);
  zendeskScript.onload = () => {
    if (typeof window.zE !== "undefined") {
      const language = channel.Vendor.Locale.split("-").shift();
      window.zE("webWidget", "setLocale", language);

      // Execute logic when the chat is displayed
      window.zE("webWidget:on", "chat:connected", _ => {
        const bottomFooterElement = document.getElementById("arc3-footer__end-row");

        // Initial call when the page is loaded
        moveWidgetFromFooter(bottomFooterElement);

        // Bind the scroll event
        window.addEventListener(
          "scroll",
          debounce(_ => {
            moveWidgetFromFooter(bottomFooterElement);
          }, 100)
        );
      });
    }
  };
};

/**
 * Moves the support widget out of the footer way
 *
 * @param  {Element} bottomFooterElement
 */
const moveWidgetFromFooter = bottomFooterElement => {
  // Check this is not the mobile viewport
  if (window.innerWidth > MOBILE_WIDTH_BREAKPOINT) {
    let verticalScroll = window.pageYOffset + window.innerHeight;

    if (verticalScroll > bottomFooterElement.offsetTop) {
      let verticalOffset = verticalScroll - bottomFooterElement.offsetTop;

      window.zESettings.webWidget.offset.vertical = verticalOffset;
      window.zESettings.webWidget.offset.mobile.vertical = verticalOffset;
      window.zE("webWidget", "updateSettings", window.zESettings);
    } else {
      window.zESettings.webWidget.offset.vertical = 0;
      window.zESettings.webWidget.offset.mobile.vertical = MOBILE_EXTRA_MARGIN;
      window.zE("webWidget", "updateSettings", window.zESettings);
    }
  }
};
